import styles from "./MyAccount.module.css";
import { useSelector } from "react-redux";

const SingleLink = ({ icon, title, onclick }) => {
  const activeAccountTab = useSelector((state) => state.activeAccountTab);
  return (
    <div
      className={`${styles.singleLink} ${
        activeAccountTab === title ? styles.singleLinkActive : null
      } cursor-pointer`}
      onClick={onclick}
      title={title}
    >
      <img src={icon} className={styles.singleLinkImg} alt="Menu Icon" />
      <p className={styles.singleLinkHeading}>{title}</p>
    </div>
  );
};

export default SingleLink;
